import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {PhrTags} from '../models/phr-tags.model';

@Injectable()
export class PhrTagsAdapter implements IAdapter<PhrTags> {
  adaptToModel(resp: any): PhrTags {
    const phrTags: PhrTags = new PhrTags();
    if (resp) {
      phrTags.id = resp.id;
      phrTags.name = resp.name;
    }
    return phrTags;
  }
  adaptFromModel(data: PhrTags): any {
    return data;
  }
}
